import React from 'react';
import PropTypes from 'prop-types';

import Grid from '../grid';
import TextInput from '../form-elements/text-input';
import MyPageForm from '../my-page-form';
import MyPageLayout from 'components/my-page-layout';
import MyPageSection from 'components/my-page-section';
import ValidationErrorTexts from 'components/validation-error-texts';

const ChangeEmailPage = ({
  form,
  layout,
  newEmail,
  oldEmail,
  section,
  validationErrors
}) => {
  return (
    <MyPageLayout {...layout}>
      <Grid theme={Grid.themes.leftColumnWider}>
        <Grid.Column>
          <MyPageSection headingLevel={1} {...section}>
            <MyPageForm {...form}>
              <TextInput
                validations="isRequired,isEmail"
                validationErrors={validationErrors}
                {...oldEmail}
              />
              <TextInput
                validations="isRequired,isEmail"
                validationErrors={validationErrors}
                {...newEmail}
              />
            </MyPageForm>
          </MyPageSection>
        </Grid.Column>
      </Grid>
    </MyPageLayout>
  );
};

ChangeEmailPage.propTypes = {
  form: PropTypes.exact(MyPageForm.propTypes),
  layout: PropTypes.exact(MyPageLayout.propTypes),
  newEmail: PropTypes.exact(TextInput.propTypes),
  oldEmail: PropTypes.exact(TextInput.propTypes),
  section: PropTypes.exact(MyPageSection.propTypes),
  validationErrors: PropTypes.exact(ValidationErrorTexts.propTypes)
};

export default ChangeEmailPage;
